import { AND } from 'shared/api/query/filter';
import { DateTime } from 'luxon';
import { GoalFilterHandler } from '@/lib/filter/goal/handler';
import { compareToDateTime } from '@/lib/compare-to';
import { computed } from 'vue';

export default function useCascadeViewParams(viewsService, defaultFilter, loggedInUserAccount, searchTerm, selectedCycles) {
  const queryFilter = computed(() => {
    if (defaultFilter === null) {
      return viewsService.currentView.value.params.filter;
    }
    if (viewsService.currentView.value.params.filter === null) {
      return {
        account: { uid: loggedInUserAccount.value.uid },
        op: AND,
        children: [defaultFilter],
      };
    }
    return {
      account: { uid: loggedInUserAccount.value.uid },
      op: AND,
      children: [defaultFilter, ...viewsService.currentView.value.params.filter.children],
    };
  });

  const gqlFilterObject = computed(() => {
    const handler = new GoalFilterHandler();
    return handler.Translate(queryFilter.value);
  });

  const compareToNow = DateTime.local();
  const compareTo = computed(() => {
    const compareTo = compareToDateTime(viewsService.currentView.value.params.compare, compareToNow);
    if (compareTo === null) {
      return [];
    }
    return [compareTo.toISO()];
  });

  const order = computed(() => {
    if (viewsService.currentView.value.params === undefined || viewsService.currentView.value.params.order === undefined) {
      return [];
    }
    return viewsService.currentView.value.params.order;
  });

  const applyFilterOnFirstLevelOnly = computed(() => viewsService.currentView.value.params.applyFilterOnFirstLevelOnly);

  const showParents = computed(() => viewsService.currentView.value.params.props.filter((p) => p.showInRowAbove === true && p.show === true).length > 0);

  return {
    order,
    applyFilterOnFirstLevelOnly,
    showParents,
    queryFilter,
    gqlFilterObject,
    compareTo,
    searchTerm,
    selectedCycles,
  };
}
